import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import JobLabels from 'components/JobLabels';
import TextWithIcon from 'components/TextWithIcon';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVacancy, selectVacanciesContent } from 'store/slices/CareerSlice';

const DetailedJob = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    // @ts-ignore
    const vacanciesContent = useSelector(selectVacanciesContent);

    const currentJob = vacanciesContent?.[slug];

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchVacancy({ slug }),
        );
    }, [dispatch, slug]);

    const { title, data, experience, locations, work_type, title_background } = currentJob || {};

    return (
        <>
            <Banner image={title_background} buttonText="!!Apply for a job">
                <h2>{title}</h2>
                <JobLabels experience={experience} locations={locations} work_type={work_type} />
                <TextWithIcon iconName="calendar" text={'!!add date'} />
            </Banner>

            <article className="article-content" dangerouslySetInnerHTML={{ __html: data }} />

            <CareerForm />
        </>
    );
};

export default DetailedJob;
